import React from 'react'

import withTranslate from 'react-redux-multilingual/lib/withTranslate'

import { Paper, Grid, withStyles, Typography, Box, Button } from '@material-ui/core'
import { CloudDownloadRounded } from '@material-ui/icons'

const ExportBox = ({ clicked, translate }) => {
  return (
    <MaximizedPaper elevation={3}>
      <DashedBox onClick={clicked} component={Button}>
        <Grid container direction={'column'} alignItems={'center'} justify={'center'}>
          <Grid item>
            <CloudDownloadRounded style={{ fontSize: 72 }} />
          </Grid>
          <Grid item>
            <Typography color={'inherit'} variant={'h5'}>
              {translate('export')}
            </Typography>
          </Grid>
        </Grid>
      </DashedBox>
    </MaximizedPaper>
  )
}

const MaximizedPaper = withStyles(theme => ({
  root: { height: '100%', minHeight: 300, padding: theme.spacing(2) }
}))(Paper)

const DashedBox = withStyles(theme => ({
  root: {
    height: '100%',
    width: '100%',
    minHeight: 350,
    color: theme.palette.info.light,
    background: theme.palette.background.default,
    padding: theme.spacing(2),
    borderColor: theme.palette.info.light,
    borderWidth: 4,
    borderSpacing: '',
    borderRadius: theme.shape.borderRadius,
    borderStyle: 'dashed'
  }
}))(Box)

export default withTranslate(ExportBox)
